import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AccessType } from '../services/userApi';

// Interface pour représenter un utilisateur connecté
export interface AuthUser {
  id: string;
  firstName: string;
  lastName: string;
  companyName?: string;
  microsoftId?: string;
  departmentId?: string;
  departmentFlags?: {
    isStore?: boolean;
    isSupplier?: boolean;
    isAccountManagement?: boolean;
  } | null;
  function: string;
  shopLocationId?: string; // ID d'emplacement Shopify, obligatoire pour les utilisateurs du département 'boutique'
  accesses: AccessType[];
  level?: 'employee' | 'manager1' | 'manager2';
  token: string;
  // Champs de périmètre de reporting
  reportingScopeType?: 'all' | 'supplier' | 'brands';
  reportingSupplierId?: string | null;
  reportingBrands?: string[];
}

// Interface pour l'état d'authentification
export interface UserState {
  currentUser: AuthUser | null;
  isAuthenticated: boolean;
  loading: boolean;
  error: string | null;
}

// État initial
const initialState: UserState = {
  currentUser: null,
  isAuthenticated: false,
  loading: false,
  error: null
};

// Créer le slice utilisateur
const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    loginStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    loginSuccess: (state, action: PayloadAction<AuthUser>) => {
      state.currentUser = action.payload;
      state.isAuthenticated = true;
      state.loading = false;
      state.error = null;
    },
    loginFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
    logout: (state) => {
      state.currentUser = null;
      state.isAuthenticated = false;
      state.error = null;
    },
    clearError: (state) => {
      state.error = null;
    }
  }
});

// Exporter les actions
export const { loginStart, loginSuccess, loginFailure, logout, clearError } = userSlice.actions;

// Exporter le reducer
export default userSlice.reducer;
